import { DropdownTypes } from '../UI/Input/Dropdown/_types';
import { TextboxTypes } from '../UI/Input/Textbox/_types';

export const defaultOfficeAddressFormConfig = {
	street1: {
		label: 'Office Address 1',
		value: '',
		visible: true,
		validation: {
			valid: true,
			message: '',
			rules: {
				required: false,
				maxLength: 64,
			},
			touched: false,
		},
		settings: {
			readOnly: false,
			type: TextboxTypes.TEXT,
			displayFor: [],
		},
	},
	street2: {
		label: 'Office Address 2',
		value: '',
		visible: true,
		validation: {
			valid: true,
			message: '',
			rules: {
				required: false,
				maxLength: 64,
			},
			touched: false,
		},
		settings: {
			readOnly: false,
			type: TextboxTypes.TEXT,
			displayFor: [],
		},
	},
	street3: {
		label: 'Office Address 3',
		value: '',
		visible: true,
		validation: {
			valid: true,
			message: '',
			rules: {
				required: false,
				maxLength: 64,
			},
			touched: false,
		},
		settings: {
			readOnly: false,
			type: TextboxTypes.TEXT,
			displayFor: [],
		},
	},
	city: {
		label: 'City',
		value: '',
		visible: true,
		validation: {
			valid: true,
			message: '',
			rules: {
				required: false,
				maxLength: 32,
			},
			touched: false,
		},
		settings: {
			readOnly: false,
			type: TextboxTypes.TEXT,
			displayFor: [],
		},
	},
	state: {
		label: 'State/Province',
		value: null,
		options: [],
		visible: true,
		validation: {
			valid: true,
			message: '',
			rules: {
				required: false,
				maxLength: 16,
				invalidIndex: 0,
			},
			touched: false,
		},
		settings: {
			readOnly: false,
			type: DropdownTypes.DROPDOWN,
			displayFor: [],
		},
	},
	zipCode: {
		label: 'Zip Code/Postal Code',
		value: '',
		visible: true,
		validation: {
			valid: true,
			message: '',
			rules: {
				required: false,
				maxLength: 20,
			},
			touched: false,
		},
		settings: {
			readOnly: false,
			type: TextboxTypes.TEXT,
			displayFor: [],
		},
	},
	country: {
		label: 'Country',
		value: null,
		options: [],
		visible: true,
		validation: {
			valid: true,
			message: '',
			rules: {
				required: false,
				maxLength: 32,
			},
			touched: false,
		},
		settings: {
			readOnly: false,
			type: DropdownTypes.DROPDOWN,
			displayFor: [],
		},
	},
};

export const defaultInternationalAddressFormConfig = {
	street: {
		label: 'Street Address',
		value: '',
		options: [],
		visible: true,
		validation: {
			valid: true,
			message: '',
			rules: {
				required: false,
				maxLength: 32,
			},
			touched: false,
		},
		settings: {
			readOnly: false,
			type: TextboxTypes.TEXT,
			displayFor: [],
		},
	},
	city: {
		label: 'City',
		value: '',
		options: [],
		visible: true,
		validation: {
			valid: true,
			message: '',
			rules: {
				required: false,
				maxLength: 32,
			},
			touched: false,
		},
		settings: {
			readOnly: false,
			type: TextboxTypes.TEXT,
			displayFor: [],
		},
	},
	state: {
		label: 'State/Province',
		value: null,
		options: [],
		visible: true,
		validation: {
			valid: true,
			message: '',
			rules: {
				required: false,
				maxLength: 32,
			},
			touched: false,
		},
		settings: {
			readOnly: false,
			type: DropdownTypes.DROPDOWN,
			displayFor: [],
		},
	},
	zipCode: {
		label: 'Zip Code/Postal Code',
		value: '',
		options: [],
		visible: true,
		validation: {
			valid: true,
			message: '',
			rules: {
				required: false,
				maxLength: 32,
			},
			touched: false,
		},
		settings: {
			readOnly: false,
			type: TextboxTypes.TEXT,
			displayFor: [],
		},
	},
	country: {
		label: 'Country',
		value: null,
		options: [],
		visible: true,
		validation: {
			valid: true,
			message: '',
			rules: {
				required: false,
				maxLength: 32,
			},
			touched: false,
		},
		settings: {
			readOnly: false,
			type: DropdownTypes.DROPDOWN,
			displayFor: [],
		},
	},
};

export const defaultUsAddressFormConfig = {
	street: {
		label: 'Street Address',
		value: '',
		options: [],
		visible: true,
		validation: {
			valid: true,
			message: '',
			rules: {
				required: false,
				maxLength: 32,
			},
			touched: false,
		},
		settings: {
			readOnly: false,
			type: TextboxTypes.TEXT,
			displayFor: [],
		},
	},
	city: {
		label: 'City',
		value: '',
		options: [],
		visible: true,
		validation: {
			valid: true,
			message: '',
			rules: {
				required: false,
				maxLength: 32,
			},
			touched: false,
		},
		settings: {
			readOnly: false,
			type: TextboxTypes.TEXT,
			displayFor: [],
		},
	},
	state: {
		label: 'State/Province',
		value: null,
		options: [],
		visible: true,
		validation: {
			valid: true,
			message: '',
			rules: {
				required: false,
				maxLength: 32,
			},
			touched: false,
		},
		settings: {
			readOnly: false,
			type: TextboxTypes.TEXT,
			displayFor: [],
		},
	},
	zipCode: {
		label: 'Zip/Postal Code',
		value: '',
		options: [],
		visible: true,
		validation: {
			valid: true,
			message: '',
			rules: {
				required: false,
				maxLength: 32,
			},
			touched: false,
		},
		settings: {
			readOnly: false,
			type: TextboxTypes.TEXT,
			displayFor: [],
		},
	},
};
